import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/help-import-guest-list";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/help/import-guest-list")({
  head: SEO["/help/import-guest-list"],
  component: () => <ContentPage path="/help/import-guest-list" body={body} />,
});
